import { useCallback } from 'react';
import type { TwirlValue } from '../../lib/filters/twirl';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Twirl panel — single signed angle slider. */
export function TwirlPanel({ value, onChange }: AdjustmentPanelProps<TwirlValue>) {
  const set = useCallback(
    (patch: Partial<TwirlValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Angle"
        min={-720}
        max={720}
        step={1}
        value={value.angle}
        onChange={(v) => set({ angle: v })}
      />
    </div>
  );
}
